import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./FeuE7OutsourcedActivities.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { FeuECommonColumns } from "../../FeuConstants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";

const FeuE7OutsourcedActivities = forwardRef(({ FeuE7OutsourcedActivitiesData, refetchMonitoringData,vesselMstId }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (FeuE7OutsourcedActivitiesData) {
            reset(prev => ({ ...prev, e7: FeuE7OutsourcedActivitiesData }));
        }
    }, [FeuE7OutsourcedActivitiesData, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("e7");
        const payload = {
            ...FeuECommonColumns.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const FeuE7OutsourcedActivities = await callApi({
                method: "POST",
                url: API_ROUTES.E7(vesselMstId),
                data: payload,
            });
            if (FeuE7OutsourcedActivities?.isSuccess) {
                emitToasterMsg("success", "Table E.7", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, e7: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table E.7", FeuE7OutsourcedActivities?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table E.7", error?.errorMessage);
        }
    };

    return (
        <div className="e7-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Outsourced activities
                    </h6>
                </MDBCol>
            </MDBRow>

            {FeuECommonColumns.map(({ label, name, maxLength, type }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`e7.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`e7_${name}`}
                                    className="textarea-resize"
                                    value={field.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />

                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="feue7_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                >
                    Save
                </Button>
            </div>
        </div>
    );
});

export default FeuE7OutsourcedActivities;
